"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (warning) {
    if (process.env.NODE_ENV !== 'production') {
        console.warn(warning);
    }
});
//# sourceMappingURL=deprecate.js.map